import React from "react";
import {Colors} from '_styles';

const CircleDigit = (props) => { 
        
    return (
            <div style={{display:'flex', marginLeft: props.margin ? 6 : 0, opacity: props.forecast ? 0.8  : 1.0, marginTop: props.marginTop ? props.marginTop : 0}}>
                <div style={{
                    backgroundColor: props.color, 
                    borderRadius:5, 
                    width:40, 
                    height:25, 
                    borderStyle: 'solid', 
                    borderColor: props.textColor, 
                    borderWidth:0.5
                }}>
                    <p style={{fontSize:14, fontWeight:'bold', color: props.type == 'total' ? Colors.PRM_LIGHT_BLUE : props.textColor ? props.textColor : 'white', textAlign:'center'}}>{props.isLoading ? '' :  props.number}</p>
                </div>
            </div>
    );
}

export default CircleDigit;